import React from "react";
import { Divider } from "@mui/material";
import { AutocompleteRenderGroupParams } from "@mui/material/Autocomplete";

import * as Styled from "./styles";

const DIVIDER_STYLE = { borderColor: "#CAC4D0", margin: "10px 0" } as const;

interface DriverGroupRowProps {
  params: AutocompleteRenderGroupParams;
  otherLabel: string;
  hasMapDrivers: boolean;
}

function DriverGroupRow({
  params,
  otherLabel,
  hasMapDrivers,
}: DriverGroupRowProps) {
  const isNoDriverGroup = params.group === "";
  const isOtherGroup = params.group === otherLabel;

  return (
    <li key={params.key}>
      {isOtherGroup ? <Divider sx={DIVIDER_STYLE} /> : null}
      {!isNoDriverGroup ? (
        <Styled.GroupHeader>{params.group}</Styled.GroupHeader>
      ) : null}
      <ul className="MuiAutocomplete-groupUl" style={{ padding: 0, margin: 0 }}>
        {params.children}
      </ul>
      {isNoDriverGroup && hasMapDrivers ? <Divider sx={DIVIDER_STYLE} /> : null}
    </li>
  );
}

export default DriverGroupRow;
